import React, { useState, useEffect } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import api from '../../utils/api';

const HousekeepingDashboard = () => {
  const [tasks, setTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get('/api/bookings/housekeeping/tasks');
      const tasksList = response.data?.tasks ?? response.data ?? [];
      setTasks(Array.isArray(tasksList) ? tasksList : []);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleCompleteTask = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    // In a real app, you'd add photos here
    // formData.append('photos', ...);

    try {
      const id = selectedTask.id ?? selectedTask._id;
      await api.patch(`/api/bookings/${id}/housekeeping/complete`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setSelectedTask(null);
      fetchData();
      alert('Task marked as completed!');
    } catch (error) {
      alert(error.response?.data?.error || 'Failed to complete task');
    }
  };

  const pendingTasks = tasks.filter(t => t.status === 'pending');
  const inProgressTasks = tasks.filter(t => t.status === 'in_progress');
  const completedTasks = tasks.filter(t => t.status === 'completed');

  return (
    <DashboardLayout title="Housekeeping Dashboard">
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Pending Tasks</h3>
          <div className="value">{pendingTasks.length}</div>
        </div>
        <div className="stat-card">
          <h3>In Progress</h3>
          <div className="value">{inProgressTasks.length}</div>
        </div>
        <div className="stat-card">
          <h3>Completed</h3>
          <div className="value">{completedTasks.length}</div>
        </div>
      </div>

      <div className="card">
        <h2>Cleaning Tasks</h2>
        <table className="table">
          <thead>
            <tr>
              <th>Task ID</th>
              <th>Property ID</th>
              <th>Booking ID</th>
              <th>Status</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => (
              <tr key={task.id}>
                <td>{task.id}</td>
                <td>{task.propertyId}</td>
                <td>{task.bookingId}</td>
                <td>
                  <span className={`badge badge-${task.status === 'completed' ? 'success' : task.status === 'in_progress' ? 'info' : 'warning'}`}>
                    {task.status}
                  </span>
                </td>
                <td>{new Date(task.createdAt).toLocaleString()}</td>
                <td>
                  {task.status !== 'completed' && (
                    <button
                      onClick={() => setSelectedTask(task)}
                      className="btn btn-success btn-sm"
                    >
                      Mark as Cleaned
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedTask && (
        <div className="card">
          <h3>Complete Cleaning Task</h3>
          <p><strong>Property ID:</strong> {selectedTask.propertyId}</p>
          <p><strong>Booking ID:</strong> {selectedTask.bookingId}</p>
          <form onSubmit={handleCompleteTask}>
            <div className="form-group">
              <label>Upload Photos (Optional - not implemented in prototype)</label>
              <input type="file" multiple disabled />
              <small style={{ color: '#666' }}>Photo upload functionality would be implemented here</small>
            </div>
            <button type="submit" className="btn btn-success">Mark as Cleaned & Ready</button>
            <button
              type="button"
              onClick={() => setSelectedTask(null)}
              className="btn btn-secondary"
              style={{ marginLeft: '10px' }}
            >
              Cancel
            </button>
          </form>
        </div>
      )}
    </DashboardLayout>
  );
};

export default HousekeepingDashboard;

